import { render, staticRenderFns } from "./import-roster.vue?vue&type=template&id=1d6e96cd&scoped=true"
import script from "./import-roster.vue?vue&type=script&lang=ts"
export * from "./import-roster.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6e96cd",
  null
  
)

export default component.exports